<template>
  <div
    class="select-container flex col"
    @mouseenter="toggleOptions(true)"
    v-if="options.length"
  >
    <div class="select flex">
      <span> {{ value }}</span>
      <img class="icon" :src="svgDown" alt="down" />
    </div>
    <ul
      :class="{ 'options-container': true, none: !showOptions }"
      @mouseleave="toggleOptions(false)"
    >
      <li
        :class="{ option: true, selected: option === value }"
        v-for="option of options"
        :key="option"
        @click="setOption(option, side)"
      >
        {{ option }}
      </li>
      <li class="option down" @click="toggleOptions(false)">
        <img class="icon" :src="svgUp" alt="up" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["value", "showOptions", "options", "side"],
  created() {},
  data() {
    return {
      svgUp: require("../../assets/svg/arrow-up.svg").default,
      svgDown: require("../../assets/svg/arrow-down.svg").default
    };
  },
  methods: {
    setOption(option, side) {
      this.$emit("setOption", { option, side });
    },
    toggleOptions(boolean) {
      this.$emit("toggleOptions", { boolean, side: this.side });
    }
  },
  components: {}
};
</script>

<style scoped>
.icon {
  fill: #333;
  height: 100%;
  width: 30px;
}
.icon:hover {
  fill: white;
}

.select-container {
  position: relative;
  width: 40%;
  height: 60px;
}
.options-container {
  width: 100%;
  position: absolute;
  transition: all 0.6s;
}

.select {
  background-color: #eeeeee;
  color: black;
  cursor: pointer;
  height: 100%;
  width: 100%;
  font-size: 20px;;
  justify-content: center;
}
.select .img-arrow {
  fill: #333333;
}
.select span {
  padding: 3px;
  align-self: center;
  font-family: "rubik";
}

.selected {
  color: black;
  background-color: #cccccc !important;
  cursor: default !important;
  text-decoration: underline;
}

.selected:hover {
  color: black !important;
}
.option {
  text-align: center;
  font-family: "rubik";
  cursor: pointer;
  background-color: #eeeeee;
  padding: 8px;
  font-size: 20px;;
  height: 100%;
}
.option:hover {
  background-color: #555fff;
  color: white;
}
</style>


// WEBPACK FOOTER //
// choose.vue?4065a011